import React, { useEffect } from "react";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaWhatsapp,
} from "react-icons/fa";
import { ArrowUp } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";

const Footer = () => {
  const { pathname } = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <footer className="bg-white text-gray-800">
      <div className="hidden sm:flex section-container text-text_color-200 mx-auto sm:px-6 p-6 flex-col sm:flex-row justify-between items-center text-xs font-medium text-primary-100">
        <NavLink to="/" className="footer_navlink">
          Home
        </NavLink>
        <NavLink to="/about" className="footer_navlink">
          About Us
        </NavLink>
        <NavLink to="/services" className="footer_navlink">
          Services
        </NavLink>
        <NavLink to="/Products" className="footer_navlink">
          Products
        </NavLink>
        <NavLink to="/industries/electronic" className="footer_navlink">
          Industries
        </NavLink>
        <NavLink to="/contact" className="footer_navlink">
          Contact us
        </NavLink>
      </div>
      <div className="mx-auto grid grid-cols-1 md:grid-cols-3 border-t border-gray-300">
        {/* Logo & Description */}
        <div className="border-r border-gray-300 px-10 pt-10">
          <img
            src={`assets/logo.png`}
            alt="logo"
            className="w-[15rem] pb-3"
          />
          <p className="font-medium text-text_color-200 mb-8">
            Shaping the Future of Packaging –<br />
            Innovative. Sustainable. Thermocol Solutions You Can Trust.
          </p>

          <div className="flex space-x-3">
            <div className="flex space-x-3">
              <a
                href="https://www.facebook.com/share/1HA7oxSLp5/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 border border-gray-300 rounded hover:bg-gray-200 transition-colors"
                aria-label="Facebook"
              >
                <FaFacebookF size={18} />
              </a>
              <a
                href="https://www.instagram.com/thermocraftofficial?igsh=MW1nZHB3cnBuNTd6MQ=="
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 border border-gray-300 rounded hover:bg-gray-200 transition-colors"
                aria-label="Instagram"
              >
                <FaInstagram size={18} />
              </a>
              <a
                href="https://wa.me/919016140083"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 border border-gray-300 rounded hover:bg-gray-200 transition-colors"
                aria-label="WhatsApp"
              >
                <FaWhatsapp size={18} />
              </a>
              <a
                href="tel:+919016140083"
                className="p-2 border border-gray-300 rounded hover:bg-gray-200 transition-colors"
                aria-label="Call"
              >
                <FaPhoneAlt size={18} />
              </a>
              <a
                href="mailto:headconnect@thermocraft.co.in"
                className="p-2 border border-gray-300 rounded hover:bg-gray-200 transition-colors"
                aria-label="Mail"
              >
                <FaEnvelope size={18} />
              </a>
            </div>
          </div>
          <div className="flex sm:hidden max-w-7xl mx-auto sm:p-6 m-5 flex-col justify-between items-start text-xs text-primary-200 font-semibold space-y-3">
            <NavLink to="/" className="footer_navlink">
              Home
            </NavLink>
            <NavLink to="/about" className="footer_navlink">
              About Us
            </NavLink>
            <NavLink to="/services" className="footer_navlink">
              Services
            </NavLink>
            <NavLink to="/Products" className="footer_navlink">
              Products
            </NavLink>
            <NavLink to="/industries/electronic" className="footer_navlink">
              Industries
            </NavLink>
            <NavLink to="/contact" className="footer_navlink">
              Contact us
            </NavLink>
          </div>
        </div>

        {/* Address */}
        <div className="border-r border-gray-300 p-10">
          <h4 className="font-bold text-sm text-primary-200 tracking-wide uppercase mb-6">
            Company Address
          </h4>
          <div className="space-y-4 text-base text-text_color-100">
            <p className="flex flex-col">
              <span className="font-semibold text-text_color-200">
                Mail to:
              </span>
              <a
                href="mailto:headconnect@thermocraft.co.in"
                className="hover:text-primary-100"
              >
                headconnect@thermocraft.co.in
              </a>
              <a
                href="mailto:support@thermocraft.co.in"
                className="hover:text-primary-100"
              >
                support@thermocraft.co.in
              </a>
            </p>
            <p className="flex flex-col">
              <span className="font-semibold text-text_color-200">Phone:</span>
              <a href="tel:+919016140083" className="hover:text-primary-100">
                +91 90161 40083
              </a>
              <a href="tel:+919081817755" className="hover:text-primary-100">
                +91 90818 17755
              </a>
            </p>

            <p className="flex flex-col">
              <span className="font-semibold text-text_color-200">
                Address:
              </span>
              <a
                href="https://www.google.com/maps/place/Tech+Park+Industrial+Society,+3,+Bhestan,+Surat,+Gujarat+395023/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline "
              >
                Ground Floor, Plot no. 3, Hi-tech Park, Pandesara,
                <br />
                Surat-394221, Gujarat, India.
              </a>
            </p>
          </div>
        </div>

        {/* Newsletter */}
        <div className="p-10">
          <h4 className="font-bold text-sm text-primary-200 tracking-wide uppercase mb-6">
            Sign up to our newsletters.
          </h4>
          <p className="text-base text-gray-600 mb-6">
            Sign up to get first dibs on new arrivals, sales, exclusive content,
            events and more!
          </p>
          <NavLink
            to="/contact"
            className="bg-primary-100 p-3 text-white text-sm font-medium"
          >
            Contact Us
          </NavLink>
        </div>
      </div>

      <hr />

      {/* Footer Bottom */}
      <div className="flax max-w-7xl p-6 text-xs text-gray-600">
        {/* <div> */}
          Copyright © 2025 Vastcon by
          <NavLink
            to="/about"
            className="text-primary-100 hover:text-primary-100/80"
          >
            ThermoCraft
          </NavLink>
          . All Rights Reserved.
      </div>

      {/* Scroll to top button */}
      <button
        onClick={scrollToTop}
        className="fixed right-6 bottom-6 p-2 bg-black text-white rounded-full shadow-lg hover:bg-gray-800 transition-colors"
        aria-label="Scroll to top"
      >
        <ArrowUp size={20} />
      </button>
    </footer>
  );
};

export default Footer;
